export default "__VITE_ASSET__uqBmpv5h__"